import { transition, trigger } from '@angular/animations';

import {
  AnimationTransition,
  applyFadeInAnimation,
  applyFadeInTranslateAnimation,
  applyFadeOutTranslateAnimation,
} from '../../core/animations';

export const ItemAvailabilityDateTimePickerModalPageAnimations = [
  trigger('animatedCalendarMessage', [transition(AnimationTransition.VoidToAny, applyFadeInAnimation({ duration: 440 }))]),
  trigger('animatedLoadingSpinner', [transition(AnimationTransition.VoidToAny, applyFadeInAnimation({ duration: 300 }))]),
  trigger('animatedErrorMessage', [
    transition(AnimationTransition.VoidToAny, applyFadeInTranslateAnimation({ duration: 300, distance: '44px' })),
    transition(AnimationTransition.AnyToVoid, applyFadeOutTranslateAnimation({ duration: 300, distance: '44px' })),
  ]),
  trigger('animatedTimePicker', [
    transition(AnimationTransition.VoidToAny, applyFadeInTranslateAnimation({ duration: 300, distance: '44px' })),
    transition(AnimationTransition.AnyToVoid, applyFadeOutTranslateAnimation({ duration: 300, distance: '44px' })),
  ]),
  trigger('animatedCalendarFooter', [
    transition(AnimationTransition.VoidToAny, applyFadeInTranslateAnimation({ duration: 240, delay: 40, distance: '-12px' })),
  ]),
];
